import React from 'react';
import classNames from 'classnames/bind';
import _noop from '../../utils/noop';
import styles from './cross.pcss';

const cx = classNames.bind(styles);

interface CrossIcon {
  sisIconColor: string;
  crossClass: string;
  onClick: () => void;
}

const CrossIcon = ({
  sisIconColor = '#202020',
  crossClass = 'crossIcon',
  onClick = _noop
}: CrossIcon): JSX.Element => (
  <div role="button" className={cx(crossClass)} onClick={onClick} tabIndex={0} aria-label='Close'>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.559"
      height="18.155"
      viewBox="0 0 19.559 18.155"
    >
      <g id="Group_3682" transform="translate(-7.734 -38.734)">
        <path
          stroke={sisIconColor}
          id="Line_546"
          d="M0 0L16.027 14.624"
          className={cx('cls-1')}
          transform="translate(9.5 40.5)"
        />
        <path
          stroke={sisIconColor}
          id="Line_547"
          d="M16.027 0L0 14.624"
          className={cx('cls-1')}
          transform="translate(9.5 40.5)"
        />
      </g>
    </svg>
  </div>
);

export default CrossIcon;
